<template>
    <modal class="tenders-modal" printButton downloadButton :close="closeModal" :printStyle="printStyle" :title="title">
        <h3 class="tenders-modal__header" slot="modalHeader">
            <i class="uk-icon-gavel"></i>
            Тендеры за {{currentYear}}
        </h3>
        <div class="tenders-modal__content tenders-content" slot="modalBody">
            <loading class="loading" v-if="isLoading" />
            <template v-if="!isLoading">
                <div class="tenders-content__chart">
                    <pie-modal-chart v-if="chartData" :data="chartData" />
                    <ul class="tenders-content__list">
                        <tenders-list-item
                            v-for="(t, i) in tendersList"
                            :key="i"
                            :tender="t" 
                            :type="currentType"
                        />
                    </ul>
                </div>
            </template> 
        </div>
        <div class="modal__footer footer" slot="modalFooter">
            <old-pagination
                class="footer__pagination"
                v-if="pagination && pagination.pages_count > 1" 
                :getNewContent="changePageHandler"
                :paginationObj="pagination" 
            />
        </div>
    </modal>
</template>

<script>
import modal from '@/components/ui/modal.vue'
import loading from '@/components/ui/loading/loading.vue'
import oldPagination from '@/components/ui/oldPagination/oldPagination.vue'
import pieModalChart from '@/components/card/tenders/pieModalChart.vue'
import tendersListItem from '@/components/card/tenders/tendersListItem.vue'

export default {
    components: {
        modal,
        loading,
        oldPagination,
        pieModalChart,
        tendersListItem
    },
    props: {
        title: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            printStyle: `
                .print-main-title { 
                    border-bottom: 1px solid #4b6365;
                    color: #4b6365;
                    font-size: 25px;
                    margin-top: 0px;
                    margin-bottom: 0px;
                    text-align: center;
                    margin-bottom: 15px;
                    margin-top: 20px; 
                }
                .modal-chart { width: 100%; display: flex; align-items: center; }
                .modal-chart__legend { width: 45%; }
                .modal-chart__legend p { font-size: 16px; }
                .chart-img-for-print img { height: 300px !important; }
                .item { position: relative; }
                .item__marker { 
                    width: 7px; 
                    height: 7px; 
                    border-radius: 50%;
                    position: absolute;
                    left: -15px;
                    top: 5px; 
                }
                li.tender-item { 
                    font-family: "Lucida Sans Unicode", "Lucida Grande", sans-serif; 
                    font-size: 16px; 
                    color: #000;
                    border-bottom: 1px solid #ddddde;
                    margin-bottom: 20px;
                    display: flex;
                    flex-direction: column;
                    gap: 5px; 
                }
                .lots p, .tender-item p { margin: 0; }
                .lots { padding: 0; margin-top: 10px; }
                .lots__info {
                    margin-left: 30px;
                    margin-top: 5px;
                    display: flex;
                    flex-direction: column;
                    gap: 5px; 
                }
                .product { list-style: disc; }
                .product .accordion .accordion__btn {
                    border: none;
                    background: none;
                    color: #3f556b;
                    font-weight: 600;
                    font-style: italic;
                }
                .uk-icon-rub:before {  
                content: "\\20BD";
                font-style: normal;
            }
            `
        }
    },
    computed: {
        isLoading() { return this.$store.state.card?.tenders?.isLoading },
        modalData() { return this.$store.state.card?.tenders?.modalData },
        currentYear() { return this.modalData?.year || new Date().getFullYear() },
        currentType() { return this.modalData?.type || 'participants' },
        pagination() { return this.$store.state.card?.tenders?.pagination },
        ogrn() { return this.$store.state.card?.company?.ogrn },
        chartData() { return this.$store.state.card?.tenders?.productsStat?.[this.currentType === 'participants' ? 'participant' : 'customer']?.[this.currentYear] },
        tendersList() { return this.$store.state.card?.tenders?.tendersList }
    },
    methods: {
        closeModal() {
            this.$store.dispatch('card/tenders/closeModal')
        },
        changePageHandler(limit = 50, offset = 0) {
            this.$store.dispatch('card/tenders/getFullInfo', {
                ogrn: this.ogrn,
                type: this.currentType,
                year: this.currentYear,
                limit,
                offset
            })
        }
    }
}
</script>

<style lang="sass" scoped>
@import 'styles/global-variables'

.tenders-modal
    &__header
        font-family: Arial,Tahoma,sans-serif
        font-size: 24px
        font-weight: 100
        color: #444
    &__content
        margin: 0
        padding: 0
        .loading
            transform: scale(1.5)
    .tenders-content
        &__chart
            margin-top: 20px
        img
            position: static
            margin: 0
            padding: 0
    .footer
        &__pagination
            float: left
</style>